import AttendanceSerializer from './base';
import { guidFor } from '@ember/object/internals';

export default class MovementCode extends AttendanceSerializer {
  normalize(type, payload) {
    payload.id = guidFor(payload);
    return super.normalize(...arguments);
  }
}
